import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAppContent, AppContentStatus } from "components/app-content";
import { ContainerWrap } from "components/wraps";
import Icons from "components/icons";
import { getGameBanner, hasPortalValue } from "./game-link";

import "./game-banners.css";

const GameBanners = () => {
    const { pathname } = useLocation();
    const { games } = useAppContent();
    const { items } = games;
    const jwtAuth = localStorage.getItem("jwtAuth");
    const jwtToken = localStorage.getItem("jwtToken");
    const eligible = (pathname === "/" || pathname === "/timeline")
        && hasPortalValue(jwtAuth) && hasPortalValue(jwtToken);
    const banners = useMemo(() => items.map((game) => getGameBanner(game, jwtToken)).filter(Boolean), [items, jwtToken]);

    if (!eligible) return null;

    return (
        <div className="game-banners">
            {banners.length > 0 && <div className="company-bg-color">
                <ContainerWrap>
                    <div className={`game-banners-grid${banners.length > 1 ? " game-banners-grid-multiple" : ""}`}>
                        {banners.map((game) => (
                            <a className="game-banner" key={game.id} href={game.href} target="_blank" rel="noopener noreferrer">
                                <span className="game-banner-content">
                                    <span aria-hidden="true"><Icons.Diamond /></span>
                                    <span className="game-banner-title">{game.title}</span>
                                    <span aria-hidden="true"><Icons.Diamond /></span>
                                </span>
                            </a>
                        ))}
                    </div>
                </ContainerWrap>
            </div>}
            {(!games.loading || banners.length === 0) && <AppContentStatus resource={games} />}
        </div>
    );
};

export default GameBanners;
